import React from 'react';
import * as motion from 'motion/react-m';

import { transparentize } from '@osmosis/shared/styles/colorModifiers';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { IconButton } from '@osmosis/tailwind-ui/components/IconButton';
import { ZIndex } from '@osmosis/tailwind-ui/helpers/zIndex';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';

import VideoRating from './VideoRating';
import VideoReplay from './VideoReplay';
import VideoNextUp from './VideoNextUp';

import { useLearnData } from '../../context/LearnDataProvider';
import { useAssessmentProgress } from '../../context/AssessmentProgressProvider';
import { fade, slideVerticalReverse } from '../../styles/animation';

type Props = {
  onHide: () => void;
  onReplay: () => void;
};

/** . */
const VideoEndOverlay = (props: Props) => {
  const { onHide, onReplay } = props;
  const { learnData } = useLearnData();
  const { assessmentProgress } = useAssessmentProgress();

  if (!learnData) return <Box />;

  const {
    sections: { questions, flashcards, notes },
    upNext,
  } = learnData;

  return (
    <motion.div
      {...fade()}
      style={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        zIndex: ZIndex.VIDEO_END_OVERLAY,
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: transparentize(0.1, '#000'),
      }}
    >
      <VideoNextUp
        questions={questions}
        flashcards={flashcards}
        assessmentProgress={assessmentProgress}
        notes={notes}
        video={upNext}
        onVideoClick={onReplay}
      />

      <Box className="m-3 absolute top-0 right-0">
        <IconButton
          data-testid="hide-video-overlay-button"
          onClick={onHide}
          variant="transparent"
          color="white"
          icon={<Icon icon={faTimes} />}
        />
      </Box>

      <Box className="m-3 absolute left-0 bottom-0">
        <VideoReplay onReplay={onReplay} />
      </Box>

      <motion.div
        {...slideVerticalReverse()}
        transition={{ delay: 1 }}
        style={{ position: 'absolute', right: 0, bottom: 0 }}
      >
        <Box className="m-3">
          <VideoRating />
        </Box>
      </motion.div>
    </motion.div>
  );
};

export default VideoEndOverlay;
